import { LookProduct } from "../../../features/looks-gallery/data/types";
import { getAssetPath } from "../../../lib/assetPath";

interface ProductCardProps {
  product: LookProduct;
}

export const ProductCard = ({ product }: ProductCardProps) => {
  return (
    <div className="flex flex-col gap-1 items-center p-2 rounded-lg bg-gradient-to-b from-[rgba(250,245,241,0.20)] to-[rgba(245,238,235,0.20)] min-w-[150px]">
      <img
        src={getAssetPath(product.imagePath)}
        alt={product.label}
        className="w-[80px] h-[112px] object-cover"
      />
      <p className="text-white text-center font-bebas-kai text-base font-normal leading-normal">
        {product.label}
      </p>
      <p className="text-white text-center font-garamond-italic text-base font-normal leading-normal">
        {product.description}
      </p>
      <p className="text-white text-center font-minion text-sm font-normal leading-normal">
        {product.detail}
      </p>
    </div>
  );
};
